import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=0351b95a&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=0351b95a&prod&scoped=true&lang=css"
import style1 from "./CreateUser.vue?vue&type=style&index=1&id=0351b95a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351b95a",
  null
  
)

export default component.exports